export const enumTemplateType = {
  unknown: 0,
  email: 1,
  phone: 2,
  sms: 3,
  letter: 4,
  documentation: 5,
}
